<template>
  <el-container v-loading="!loading">
    <template v-if="loading">
      <el-aside class="aside">
        <layout-nav />
      </el-aside>
      <el-main class="main">
        <div class="layoutMain">
          <router-view v-slot="{ Component, route }">
            <keep-alive>
              <component class="layoutViews" :is="Component" :key="Math.random()" />
            </keep-alive>
          </router-view>
        </div>
      </el-main>
    </template>
  </el-container>
</template>

<script setup lang="ts">
import LayoutNav from "../layoutNavCustomerManage.vue";
import { onMounted, ref, computed } from "vue";
import useInitData from "@/hooks/useInitData";
import { onBeforeRouteUpdate } from "vue-router";
import { useStore } from "vuex";
import enterprisePowerApi from "@/api/enterprisePowerApi/enterprisePowerApi";
const store = useStore();
const { initData, isPower } = useInitData();
const loading = ref(false);
const getThisCompany = computed(() => store.getters.getThisCompany);

onMounted(async () => {
  await initData();
  await GetUserPermission();
  loading.value = true;
});
onBeforeRouteUpdate((to) => {
  isPower(store.getters.getCurrentPower, to.name as string);
});
const GetUserPermission = async () => {
  const userAuth = await enterprisePowerApi.GetUserPermission(store.getters.getUserinfo("userid"));
  await store.dispatch("setCustomerAuths", userAuth.data);
};
</script>

<style lang="less" scoped>
.aside {
  width: @navWidth;
}
.main {
  background: @mainBg;
  padding: @padding;
  display: flex;
  flex-direction: column;
  .layoutMain {
    background-color: #fff;
    flex: 1;
    overflow: auto;
    position: relative;
  }
  :deep(.layoutViews) {
    box-sizing: border-box;
    height: 100%;
    padding: 20px 0;
    overflow: hidden;
    display: flex;
  }
  .flex {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100%;
    img {
      width: 20vw;
      min-width: 400px;
    }
    span {
      margin-top: 10px;
      color: #666;
      font-size: 1vw;
    }
  }
}
</style>
